module.exports = __webpack_public_path__ + "img/7d67cb4.png";